export default __webpack_public_path__ + "static/media/img2.cb61b829.svg";